import common from './modules/common.zh-CN'
import home from './modules/home.zh-CN'
import lighting from './modules/lighting.zh-CN'
import setting from './modules/setting.zh-CN'
import toast from './modules/toast.zh-CN'
import itinerary from './modules/itinerary.zh-CN'
import keys from './modules/keys.zh-CN'
import dpi from './modules/dpi.zh-CN'
import performance from './modules/performance.zh-CN'
import parameters from './modules/parameters.zh-CN'
import server from './modules/server.zh-CN'
import tray from './modules/tray.zh-CN'
import notice from './modules/notice.zh-CN'
import pageAndPlayer from './modules/pageAndPlayer.zh-CN'
import rt from './modules/rt.zh-CN'

export default {
  common,
  home,
  lighting,
  setting,
  toast,
  itinerary,
  keys,
  dpi,
  performance,
  parameters,
  server,
  tray,
  notice,
  pageAndPlayer,
  rt,
}
